import React from 'react';

import FooterOne from '../layout/Footer/FooterOne';
import Navbar from '../layout/Header/Navbar';
import Layout from '../layout/Layout';
import PageMeta from '../components/common/PageMeta';
import HeroEightCustom from './HeroEightCustom';

import TrialBanner from "../components/trial/trialbanner";

const json = {
    "mcpServers": {
         "sftp": {
              "command": "docker",
              "args": [
                   "run",
                   "-i",
                   "--rm",
                   "-e",
                   "SFTP_HOST",
                   "-e",
                   "SFTP_USERNAME",
                   "-e",
                   "SFTP_PASSWORD",
                   "filepulse/sftp-mcp-server"
              ],
              "env": {
                "SFTP_HOST": "HOSTNAME",
                "SFTP_USERNAME":"USERNAME",
                "SFTP_PASSWORD": "PASSWORD"
              }
         }
    }
  }

const jsonKey = {
    "mcpServers": {
         "sftp": {
              "command": "docker",
              "args": [
                   "run",
                   "-i",
                   "--rm",
                   "-v",
                   "PATH_TO_KEY_FILE:/root/.ssh/id_rsa:ro", 
                   "-e",
                   "SFTP_HOST",
                   "-e",
                   "SFTP_USERNAME",
                   "-e",
                   "SSH_KEY_PATH",
                   "filepulse/sftp-mcp-server"
              ],
              "env": {
                   "SFTP_HOST": "HOSTNAME",
                   "SFTP_USERNAME": "USERNAME",
                   "SSH_KEY_PATH": "/root/.ssh/id_rsa"
              }
         }
    }
}

const BlogDetails = () => {
    const inlineCodeStyle = {
        backgroundColor: '#f5f5f5',
        fontFamily: 'monospace',
        fontSize: '0.95em',
        padding: '2px 4px',
        borderRadius: '4px',
        color: '#c7254e',
        border: '1px solid #e1e1e8',
      };
    return (
        <>
            <Layout>
                <PageMeta title='SFTP MCP Server Setup' description="Complete SFTP MCP Setup guide, integrate an SFTP connection in Claude desktop." />
                <Navbar navDark />
                <HeroEightCustom>
                    How to setup the SFTP MCP Server
                </HeroEightCustom>

                <section className='blog-details ptb-120'>
                    <div className='container'>
                        <div className='row justify-content-between'>
                            <div className='col-lg-9 pe-5'>
                                <div className='blog-details-wrap'>
                                    <h3>1. Clone the Repository</h3>
                                    <p>
                                        <b>Prerequisites:</b>  
                                        Ensure that Docker is installed on your machine and is actively running. You can verify this by running <code>docker --version</code> in your terminal. If it's not installed, refer to the official Docker documentation for setup instructions.
                                    </p>
                                    <p>
                                        Once Docker is confirmed to be running, begin by cloning the SFTP MCP server repository to your local machine using Git. This will give you access to the project files needed to proceed with the setup.
                                    </p>
                                    <code style={inlineCodeStyle}>
                                        git clone https://github.com/filepulse/sftp-mcp-server
                                        
                                    </code>

                                    <p>
                                    <code style={inlineCodeStyle}>
                                    cd sftp-mcp-server
                                    </code>
                                    </p>
                                    

                                    <h3 className="mt-40">2.  Build the Container (or Pull from Docker Hub)</h3>
                                    <p>
                                        You have two options to get the SFTP MCP server container up and running: you can either build the Docker image locally or pull a prebuilt version from a Docker registry, depending on your preference and environment setup.
                                    </p>

                                    <p><b>Option A: Build Locally</b></p>

                                    <code style={inlineCodeStyle}>
                                        docker build -t sftp-mcp-server .
                                    </code>

                                    <p>
                                        This command builds a Docker image named <code>sftp-mcp-server</code> using the <code>Dockerfile</code> included in the cloned repository. This approach is useful if you want full control over the build process or need to customize the image.
                                    </p>

                                    <p><b>Option B: Pull from Docker Registry</b></p>

                                    <p>
                                        To save time and skip the local build, you can pull a prebuilt image directly from Docker Hub or your organization’s private registry:
                                    </p>

                                    <code style={inlineCodeStyle}>
                                        docker pull filepulse/sftp-mcp-server
                                    </code>

                                    <p>
                                        This method is ideal for quickly getting started without modifying the image.
                                    </p>

                                    <h3 className="mt-40">3.  Update the Claude Desktop Configuration</h3>
                                    <p>
                                    Open the Claude desktop application, navigate to the <b>Settings</b>, and select the <b>"Edit config"</b> option under the <b>Developer</b> tab. This action will generate an empty configuration file located at:
                                </p>

                                    <p>
                                        <code style={inlineCodeStyle}>
                                        Mac OS: ~/Library/Application Support/Claude/claude_desktop_config.json
                                    </code>

                                    </p>
                                    <p> <code style={inlineCodeStyle}>
                                        Windows: %APPDATA%\Claude\claude_desktop_config.json
                                    </code>
                                   </p>
                                    

                                    <div className='row mb-40'>
                                    <div className='col-lg-6 col-12 order-lg-0'>
                                            <img
                                                src='/assets/blog/claude_desktop_1.png'
                                                className='img-fluid'
                                                alt='feature-img'
                                            />
                                  
                              
                                    </div>
                                    <div className='col-lg-6 col-12 order-lg-0'>
                                          
                              
                                            <img
                                                src='/assets/blog/claude_desktop_2.png'
                                                className='img-fluid'
                                                alt='feature-img'
                                            />
                                    </div>

                                    </div>
                                      <p className='mt-40'>
                                        Next, copy the configuration settings below into the newly created file. Be sure to replace the placeholder values with your actual credentials and server details to ensure proper connectivity.
                                    </p>
                                    <p>
                                        If you don’t currently have access to an SFTP server, you can easily set one up for free by signing up <a href="https://documentation.filepulse.io/managed/signup/" target="_blank" rel="noopener noreferrer">here</a>.
                                    </p>

                                    <p className='mt-30'>
                                    <pre style={inlineCodeStyle}>
                                        <code>
                                        {JSON.stringify(json, null, 5)}

                                        </code>
                                    </pre>

                                    </p>

                                    <p>
                                        After updating the file, save it and restart claude desktop.
                                    </p>

                                    <h4>Connecting using an SSH Keyfile</h4>
                                    <p>Alternatively you can access the sftp server using a SSH keyfile. Make sure to update PATH_TO_KEY_FILE and to remove the SFTP_PASSWORD environmental variable. </p>
                                    <p className='mt-30'>
                                    <pre style={inlineCodeStyle}>
                                        <code>
                                        {JSON.stringify(jsonKey, null, 5)}

                                        </code>
                                    </pre>
                                    </p>


                                    <h3 className="mt-40">4. Try it out!</h3>

                                    <p>
                                    If everything worked correctly, you should now see the MCP tool and resources in the Claude desktop interface.

                                    </p>

                                    <div className='col-lg-6 col-12 order-lg-0'>
                                          
                              
                                          <img
                                              src='/assets/blog/claude_desktop_3.png'
                                              className='img-fluid'
                                              alt='feature-img'
                                          />
                                  </div>

                                

                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                <TrialBanner />

                <FooterOne footerLight />
            </Layout>
        </>
    );
};

export default BlogDetails;
